var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('top-nav',{attrs:{"color":_vm.color}}),_c('transition',{attrs:{"mode":"out-in"}},[_c('keep-alive',[_c('router-view')],1)],1),_c('footer-bot',{attrs:{"data-ani":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }